<template>
  <div class="flex column items-center justify-center full-height q-py-xl q-my-xl">
    <img
      src="/404_blog.svg"
      alt="not found"
      :style="{ maxWidth: $q.platform.is.mobile ? '200px' : '395px' }"
      class="q-mb-xl"
    >
    <div
      style="max-width: 200px;"
      class="items-center flex column text-center"
    >
      <div class="text-black fs-16 q-mb-lg">{{ t('text.sorryPageNotFound') }}</div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
